













import Vue from "vue";
import ToolbarBell from "@/components/buttons/ToolbarBell.vue";
import { Statistics } from "@infoland/iprova-api";
export default Vue.extend({
    name: "ToolbarTasks",
    components: { ToolbarBell },
    props: {
        portalId: Number,
        isAnonymousUser: Boolean
    },
    computed: {
        userStatistics(): Statistics | null {
            if (this.isAnonymousUser || !this.$user) return null;
            return this.$user.statistics;
        },
        showTasksAndSubscriptions(): boolean {
            return this.$user.show_tasks_and_subscriptions;
        }
    }
});
